export default "__VITE_ASSET__CdJQp$pj__"